<fieldset class="flex border-none p-0 font-roboto text-radio items-start flex-wrap" [ngClass]="{ 'flex-col': layout === 'vertical' }">
    <legend class="p-0 mb-xs">
        {{ label }}
    </legend>
    <ng-content></ng-content>
</fieldset>
